import Parallax from 'parallax-js';
// eslint-disable-next-line no-unused-vars
import swipe from 'jquery-touchswipe';
// import './vendor/ScrollMagic.js';
// import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import vars from './vars';
import {router} from './router';
import AOS from 'aos';
window.AOS = AOS;

AOS.init({
	offset: 60,
	duration: 700,
	delay: 60,
	once: true,
	disable: innerWidth <= 1024,
});

let scrollWidth;

let parallaxScene;

let animateMobileMain = false;

// eslint-disable-next-line no-unused-vars
let parallaxInstance;

function vw(value) {
	if (innerWidth <= 1920) {
		return value / 1400 * innerWidth;
	}

	return value / 1400 * 1920;
}

let testAnimated = false;

let blocks;

function animateScroll() {
	if (vars.$html.data('page') !== 'result') {
		// eslint-disable-next-line no-underscore-dangle
		window._autoscroll_ = false;

		if ($(document.documentElement).hasClass('is-browser-ie')) {
			$('body').on('mousewheel', () => {
				event.preventDefault();

				let wheelDelta = event.wheelDelta;

				let currentScrollPosition = window.pageYOffset;

				window.scrollTo(0, currentScrollPosition - wheelDelta);
			});
		}

		let inertia = 1000;

		let delta = 30;

		if (vars.$html.hasClass('is-os-mac-os')) {
			inertia = 500;
			delta = 10;
		}

		// eslint-disable-next-line no-underscore-dangle
		if (!window._autoscroll_) {
			vars.$siteContainer.mCustomScrollbar({
				theme: 'dark',
				contentTouchScroll: 30,
				scrollInertia: inertia,
				mouseWheel: {
					deltaFactor: delta,
				},
				advanced: {
					autoUpdateTimeout: 60,
				},
				callbacks: {
					whileScrolling: () => {
						if (!window.controller) {
							return;
						}

						// eslint-disable-next-line no-undef
						controller.update(true);
					},
				},
			});

			// eslint-disable-next-line no-underscore-dangle
			window._util.get.mCSB_container = $('#mCSB_1_container').get(0);
		}

		window.controller = new ScrollMagic.Controller({
			refreshInterval: 100,
		});

		// eslint-disable-next-line no-undef
		controller.scrollPos(() => {
			// eslint-disable-next-line no-underscore-dangle
			if (window._autoscroll_) {
				// eslint-disable-next-line
				return (parseInt((vars.$slider[0].style || {}).top, 10) * -1) || 0;
				// eslint-disable-next-line no-else-return
			} else {
				// eslint-disable-next-line
				return (parseInt((window._util.get.mCSB_container.style || {}).top, 10) * -1) || 0;
			}
		});
	}

	blocks.forEach(({elements, scrollDuration, start, animation, enter, leave}) => {
		let tween = new TimelineMax();

		elements.forEach(({$element, durationCoeff, params}) => {
			tween = tween[animation || 'to']($element, durationCoeff, ...params, 0);
		});

		new ScrollMagic.Scene({
			triggerElement: '#trigger',
			duration: scrollDuration,
			offset: start,
		})
			.setTween(tween)
			// eslint-disable-next-line no-undef
			.addTo(controller)
			.on('enter', (event) => {
				enter(event);
			})
			.on('leave', (event) => {
				leave(event);
			});
	});
}

function swipeToTest() {
	new TimelineMax()
		.to(vars.$pageMain, 0.7, {
			onStart() {
				vars.$siteContainer.removeClass('page-main').addClass('page-test');
			},
			onComplete() {
				vars.$pageMain.addClass('is-hidden');
			},
			y: '-50%',
			autoAlpha: 0,
			clearProps: 'all',
		}, 0)
		.from(vars.$pageTest, 0.7, {
			onStart() {
				vars.$pageTest.removeClass('is-hidden');
				vars.$header.addClass('on-test');
			},
			onComplete() {
				router.navigate('/test');
				ga('send', 'event', 'test', `question show ${1}`, 'Выберите один из вариантов');
			},
			y: '50%',
			autoAlpha: 0,
			clearProps: 'all',
		}, 0);
}

function swipeToMain() {
	new TimelineMax()
		.to(vars.$pageTest, 0.7, {
			onStart() {
				vars.$header.removeClass('on-test');
				vars.$siteContainer.addClass('page-main').removeClass('page-test');
			},
			onComplete() {
				vars.$pageTest.addClass('is-hidden');
			},
			y: '50%',
			autoAlpha: 0,
			clearProps: 'all',
		}, 0)
		.from(vars.$pageMain, 0.7, {
			onStart() {
				vars.$pageMain.removeClass('is-hidden');
			},
			onComplete() {
				router.navigate('/');
			},
			y: '-50%',
			autoAlpha: 0,
			clearProps: 'all',
		}, 0);
}

export function showMain() {
	return new Promise((resolve) => {
		new TimelineMax({
			onStart() {
				vars.$html
					.attr('data-page', 'main')
					.data('page', 'main');
				window.scrollTo(0, 0);
				vars.$siteContainer.addClass('page-main is-overflow-hidden').removeClass('is-hidden page-test');
				// scrollBarWidth();
				vars.$html.addClass('height-100vh');
				$('.lines').removeClass('is-hidden');
				$('.social').removeClass('is-hidden');
				vars.$pageMain.removeClass('is-hidden').css({
					width: `calc(100vw - ${scrollWidth}px)`,
				});
				vars.$header.css({
					width: `calc(100vw - ${scrollWidth}px)`,
				});
				vars.$social.css({
					transform: `translateX(${-scrollWidth}px)`,
				});
			},
			onComplete() {
				vars.$html.removeClass('height-100vh');
				vars.$pageMain.attr('style', '');
				vars.$header.attr('style', '');
				vars.$social.attr('style', '');
				vars.$siteContainer.removeClass('is-overflow-hidden');
				if (innerWidth > 1024) {
					animateScroll();
				}
				resolve();
			},
		})
			.from(vars.$body, 0.7, {
				autoAlpha: 0,
				clearProps: 'all',
			})
			.from(vars.$mainItem1, 0.4, {
				autoAlpha: 0,
				x: -30,
				clearProps: 'all',
			})
			.from(vars.$mainItem2, 0.4, {
				autoAlpha: 0,
				x: -30,
				clearProps: 'all',
			}, 1)
			.from(vars.$mainItem3, 0.4, {
				autoAlpha: 0,
				x: -30,
				clearProps: 'all',
			}, 1.3);
	});
}

export function showTest(prevpage) {
	return new Promise((resolve) => {
		if (prevpage) {
			new TimelineMax({
				onStart() {
					vars.$html
						.attr('data-page', 'test')
						.data('page', 'test');
					vars.$siteContainer.removeClass('is-hidden').addClass('page-main page-test');
					$('.main__scroll').addClass('is-hidden');
					$('.page.main').addClass('is-over-hidden');
					$('.social').removeClass('is-hidden');
					$('.lines').removeClass('is-hidden');
					if (innerWidth < 1024) {
						vars.$pageTest.removeClass('is-hidden');
						vars.$header.addClass('on-test');
					}
				},
				onComplete() {
					if (innerWidth > 1024) {
						animateScroll();
						vars.$siteContainer.mCustomScrollbar('scrollTo', $('.mCSB_container').height() - innerHeight - 501, {
							timeout: 0,
							scrollInertia: 0,
						});
						setTimeout(() => {
							vars.$siteContainer.mCustomScrollbar('scrollTo', $('.mCSB_container').height() - innerHeight);
						}, 100);
						setTimeout(() => {
							$('.page.main').removeClass('is-over-hidden');
						}, 500);
					} else {
						$('.page.main').removeClass('is-over-hidden');
					}
					ga('send', 'event', 'test', `question show ${1}`, 'Выберите один из вариантов');
					resolve();
				},
			})
				.from(vars.$body, 0.7, {
					autoAlpha: 0,
				});
		} else {
			testAnimated = true;
			new TimelineMax({
				onStart() {
					vars.$html
						.attr('data-page', 'test')
						.data('page', 'test');
				},
				onComplete() {
					resolve();
				},
			})
				.add(() => {
					$('.header').addClass('on-test');
				})
				.fromTo($('.test__item__decoration'), 0.7, {
					scaleX: 0,
				}, {
					scaleX: 1,
					clearProps: 'all',
				}, 0)
				.fromTo($('.test__option'), 0.5, {
					autoAlpha: 0,
				}, {
					autoAlpha: 1,
					clearProps: 'all',
				})
				.fromTo([vars.$pageTestDescription, vars.$pageTestCounter], 0.5, {
					autoAlpha: 0,
				}, {
					autoAlpha: 1,
					ease: Power0.easeNone,
					clearProps: 'all',
				})
				.fromTo($('.test__optionality'), 0.5, {
					autoAlpha: 0,
				}, {
					autoAlpha: 1,
					ease: Power0.easeNone,
					clearProps: 'all',
				});
		}
	});
}

export function showResult(id, prevPage, prevTest) {
	let delay = 0.7;

	return new Promise((resolve) => {
		let timeline = new TimelineMax({
			onStart() {
				vars.$html
					.attr('data-page', 'result')
					.data('page', 'result');
				window.scrollTo(0, 0);
				vars.$siteContainer.removeClass('is-hidden');
				$('.lines').addClass('is-hidden');
				$('.social').addClass('is-hidden');
				$(`.page.result[data-result="${id}"]`).removeClass('is-hidden');
				if (innerWidth <= 1024) {
					let $img = '<img src="" alt="">';

					let lazyImg = $(`.page.result[data-result="${id}"]`).find('.result__img-also');

					lazyImg.each((index, item) => {
						let src = $(item).attr('data-src');

						$(item).prepend($img);
						$(item).find('img').attr('src', src);
					});
				}
			},
			onComplete() {
				AOS.init({
					offset: 120,
					duration: 500,
					delay: 60,
					once: false,
					disable: innerWidth <= 1024,
				});
				vars.$siteContainer.removeClass('no-bg');

				if (innerWidth > 1024) {
					parallaxScene = $(`.page.result[data-result="${id}"]`).find('.result__items').get(0);

					parallaxInstance = new Parallax(parallaxScene);
				} else {
					$('.result__slider').slick({
						infinite: true,
						dots: false,
					});
				}

				if (prevTest) {
					$(document).trigger('show-result');
				}

				resolve();
			},
		});

		if (innerWidth > 1024) {
			timeline
				.add(() => {
					if (!prevPage) {
						new TimelineMax({
							onStart() {
								vars.$header.addClass('on-test');
							},
						})
							.from(vars.$body, 0.7, {
								autoAlpha: 0,
								clearProps: 'all',
							});
					} else {
						new TimelineMax()
							.from($(`.page.result[data-result="${id}"]`), 0.7, {
								autoAlpha: 0,
								clearProps: 'all',
							});
					}
				})
				.from($(`.page.result[data-result="${id}"]`).find('.result__circle'), 0.7, {
					autoAlpha: 0,
					y: -200,
					clearProps: 'all',
				}, delay)
				.staggerFrom($(`.page.result[data-result="${id}"]`).find('.from-fade'), 0.4, {
					autoAlpha: 0,
					clearProps: 'all',
					stagger: 0.3,
				}, delay + 0.7);
		} else {
			timeline
				.add(() => {
					if (!prevPage) {
						new TimelineMax({
							onStart() {
								vars.$header.addClass('on-test');
							},
						})
							.from(vars.$body, 0.7, {
								autoAlpha: 0,
								clearProps: 'all',
							});
					} else {
						new TimelineMax()
							.from($(`.page.result[data-result="${id}"]`), 0.7, {
								autoAlpha: 0,
								clearProps: 'all',
							});
					}
				});
		}
	});
}

export function showArticle(id, prevPage) {
	return new Promise((resolve) => {
		new TimelineMax({
			onStart() {
				vars.$html
					.attr('data-page', 'article')
					.data('page', 'article');
				window.scrollTo(0, 0);
				vars.$siteContainer.removeClass('is-hidden');
				$('.lines').addClass('is-hidden');
				$('.social').addClass('is-hidden');
				$(`.page.article[data-article="${id}"]`).removeClass('is-hidden');
				$('.article__banner').removeClass('is-shown');
			},
			onComplete() {
				AOS.init({
					offset: 60,
					duration: 500,
					delay: 60,
					once: false,
					disable: innerWidth <= 1024,
				});
				vars.$siteContainer.removeClass('no-bg');

				let parallaxInstances = [];

				$(`.page.article[data-article="${id}"]`).find('.article__male__item__image').each((index, item) => {
					parallaxInstances.push(new Parallax(item));
				});

				resolve();
			},
		})
			.add(() => {
				if (!prevPage) {
					new TimelineMax({
						onStart() {
							vars.$header.addClass('on-test');
						},
					})
						.from(vars.$body, 0.7, {
							autoAlpha: 0,
							clearProps: 'all',
						});
				} else {
					new TimelineMax()
						.from($(`.page.article[data-article="${id}"]`), 0.7, {
							autoAlpha: 0,
							clearProps: 'all',
						});
				}
			})
			.from($('.article__title'), 0.4, {
				autoAlpha: 0,
				y: 50,
				clearProps: 'all',
			})
			.from($('.article__subtitle'), 0.4, {
				autoAlpha: 0,
				y: 50,
				clearProps: 'all',
			})
			.from($('.article__photos__text'), 0.4, {
				autoAlpha: 0,
				x: -50,
				clearProps: 'all',
			})
			.from($(`.article[data-article="${id}"]`).find('.article__photos__item').eq(0), 0.4, {
				autoAlpha: 0,
				x: -50,
				clearProps: 'all',
			})
			.from($(`.article[data-article="${id}"]`).find('.article__photos__item').eq(1), 0.4, {
				autoAlpha: 0,
				y: -50,
				clearProps: 'all',
			})
			.from($(`.article[data-article="${id}"]`).find('.article__photos__item').eq(2), 0.4, {
				autoAlpha: 0,
				x: 50,
				clearProps: 'all',
			});
	});
}

export function showMobileArticle(id, prevPage) {
	return new Promise((resolve) => {
		new TimelineMax({
			onStart() {
				vars.$html
					.attr('data-page', 'article')
					.data('page', 'article');
				window.scrollTo(0, 0);
				vars.$siteContainer.removeClass('is-hidden');
				$('.lines').addClass('is-hidden');
				$('.social').addClass('is-hidden');
				$(`.page.article[data-article="${id}"]`).removeClass('is-hidden');
			},
			onComplete() {
				vars.$siteContainer.removeClass('no-bg');

				resolve();
			},
		})
			.add(() => {
				if (!prevPage) {
					new TimelineMax({
						onStart() {
							vars.$header.addClass('on-test');
						},
					})
						.from(vars.$body, 0.7, {
							autoAlpha: 0,
							clearProps: 'all',
						});
				} else {
					new TimelineMax()
						.from($(`.page.article[data-article="${id}"]`), 0.7, {
							autoAlpha: 0,
							clearProps: 'all',
						});
				}
			});
	});
}

export function pageTransition(animation, id) {
	return new Promise((resolve) => {
		let timeline = new TimelineMax({
			onComplete() {
				vars.$page.addClass('is-hidden');
				vars.$siteContainer.addClass('is-hidden');
				vars.$mobileNav.addClass('is-hidden');
				vars.$body.removeClass('is-open-menu');

				TweenMax.set([vars.$siteContainer], {
					clearProps: 'all',
				});

				animation(id);
				resolve();
			},
		});

		timeline
			.to(vars.$siteContainer, 0.5, {
				autoAlpha: 0,
			});
	});
}

export function goFromTestToResult(id, prevTest) {
	new TimelineMax({
		onStart() {
			$('.site-container').addClass('no-bg');
		},
		onComplete() {
			if (innerWidth > 1024) {
				// eslint-disable-next-line no-undef
				controller.enabled(false).update(true);
			}
			vars.$siteContainer.removeClass('page-main page-test');
			vars.$siteContainer.mCustomScrollbar('destroy');
			vars.$pageTest.addClass('is-hidden');
			vars.$pageMain.addClass('is-hidden');
			$('.main__scroll').addClass('is-hidden');
			$('.social').addClass('is-hidden');
			TweenMax.set([$('.test__item'), vars.$pageTestDescription, vars.$pageTestCounter, $('.test__optionality'), $('.main__scroll')], {clearProps: 'all'});
			showResult(id, true, prevTest);
		},
	})
		.to($('.test__item').eq(0), 0.5, {
			top: '-100%',
		}, 0)
		.to($('.test__item').eq(1), 0.5, {
			top: '100%',
		}, 0)
		.to([vars.$pageTestDescription, vars.$pageTestCounter], 0.5, {
			autoAlpha: 0,
		}, 0)
		.to($('.test__optionality'), 0.5, {
			autoAlpha: 0,
		}, 0)
		.to($('.main__scroll'), 0.3, {
			autoAlpha: 0,
		}, 0)
		.to($('.social'), 0.3, {
			autoAlpha: 0,
		}, 0);
}

export function goFromTestToArticle(id) {
	new TimelineMax({
		onStart() {
			$('.site-container').addClass('no-bg');
		},
		onComplete() {
			// eslint-disable-next-line no-undef
			controller.enabled(false).update(true);
			vars.$siteContainer.mCustomScrollbar('destroy');
			vars.$siteContainer.removeClass('page-main page-test');
			vars.$pageTest.addClass('is-hidden');
			vars.$pageMain.addClass('is-hidden');
			$('.main__scroll').addClass('is-hidden');
			$('.social').addClass('is-hidden');
			TweenMax.set([$('.test__item'), vars.$pageTestDescription, vars.$pageTestCounter, $('.test__optionality'), $('.main__scroll')], {clearProps: 'all'});
			showArticle(id, true);
		},
	})
		.to($('.test__item').eq(0), 0.5, {
			top: '-100%',
		}, 0)
		.to($('.test__item').eq(1), 0.5, {
			top: '100%',
		}, 0)
		.to([vars.$pageTestDescription, vars.$pageTestCounter], 0.5, {
			autoAlpha: 0,
		}, 0)
		.to($('.test__optionality'), 0.5, {
			autoAlpha: 0,
		}, 0)
		.to($('.main__scroll'), 0.3, {
			autoAlpha: 0,
		}, 0)
		.to($('.social'), 0.3, {
			autoAlpha: 0,
		}, 0);
}

export function goFromResultToMain() {
	new TimelineMax({
		onComplete() {
			vars.$siteContainer.addClass('is-hidden');
			$('.header').removeClass('on-test');
			$('.main__scroll').removeClass('is-hidden');
			$('.social').removeClass('is-hidden');
			$('.page.result').addClass('is-hidden');
			TweenMax.set(vars.$siteContainer, {clearProps: 'all'});
			document.location.reload(true);
		},
	})
		.to(vars.$siteContainer, 0.7, {
			autoAlpha: 0,
		});
}

export function goFromTestToMain() {
	let timeline = new TimelineMax({
		onStart() {
			vars.$header.removeClass('on-test');
			vars.$body.removeClass('is-open-menu');
		},
		onComplete() {
			vars.$pageMain.removeClass('is-hidden');
			vars.$pageTest.addClass('is-hidden');
			$('.mobile-nav').addClass('is-hidden');
			TweenMax.set(vars.$siteContainer, {clearProps: 'all'});
			router.navigate('/');
		},
	});

	if (animateMobileMain) {
		timeline
			.to(vars.$siteContainer, 0.7, {
				autoAlpha: 0,
			});
	}
}

export function goFromResultToTest() {
	new TimelineMax({
		onComplete() {
			vars.$siteContainer.addClass('is-hidden');
			$('.page.result').addClass('is-hidden');
			TweenMax.set(vars.$siteContainer, {clearProps: 'all'});
			document.location.reload(true);
		},
	})
		.to(vars.$siteContainer, 0.7, {
			autoAlpha: 0,
		});
}

export function goFromResultToResult(id) {
	new TimelineMax({
		onComplete() {
			vars.$siteContainer.addClass('is-hidden');
			$('.page.result').addClass('is-hidden');
			TweenMax.set(vars.$siteContainer, {clearProps: 'all'});
			showResult(id);
		},
	})
		.to(vars.$siteContainer, 0.7, {
			autoAlpha: 0,
		});
}

export function goFromResultToArticle(id) {
	new TimelineMax({
		onComplete() {
			vars.$siteContainer.addClass('is-hidden');
			$('.page.result').addClass('is-hidden');
			TweenMax.set(vars.$siteContainer, {clearProps: 'all'});
			showArticle(id);
		},
	})
		.to(vars.$siteContainer, 0.7, {
			autoAlpha: 0,
		});
}

export function goFromMainToArticle(id) {
	new TimelineMax({
		onStart() {
			vars.goToArticle = true;
		},
		onComplete() {
			// eslint-disable-next-line no-undef
			controller.enabled(false).update(true);
			$('.main__scroll').addClass('is-hidden');
			$('.social').addClass('is-hidden');
			$('.page.main').addClass('is-hidden');
			vars.$siteContainer.addClass('is-hidden');
			vars.$siteContainer.removeClass('is-overflow-hidden');
			vars.$siteContainer.removeClass('page-main').addClass('page-test');
			vars.$siteContainer.mCustomScrollbar('destroy');
			$('.page.result').addClass('is-hidden');
			TweenMax.set(vars.$siteContainer, {clearProps: 'all'});
			showArticle(id);
		},
	})
		.to(vars.$siteContainer, 0.7, {
			autoAlpha: 0,
		});
}

export function goFromArticleToMain() {
	new TimelineMax({
		onComplete() {
			vars.$siteContainer.addClass('is-hidden');
			$('.header').removeClass('on-test');
			$('.main__scroll').removeClass('is-hidden');
			$('.social').removeClass('is-hidden');
			$('.page.article').addClass('is-hidden');
			TweenMax.set(vars.$siteContainer, {clearProps: 'all'});
			document.location.reload(true);
		},
	})
		.to(vars.$siteContainer, 0.7, {
			autoAlpha: 0,
		});
}

export function goFromArticleToArticle(id) {
	new TimelineMax({
		onComplete() {
			vars.$siteContainer.addClass('is-hidden');
			$('.page.article').addClass('is-hidden');
			TweenMax.set(vars.$siteContainer, {clearProps: 'all'});
			showArticle(id);
		},
	})
		.to(vars.$siteContainer, 0.7, {
			autoAlpha: 0,
		});
}

export function goFromArticleToTest() {
	new TimelineMax({
		onComplete() {
			vars.$siteContainer.addClass('is-hidden');
			$('.page.article').addClass('is-hidden');
			TweenMax.set(vars.$siteContainer, {clearProps: 'all'});
			document.location.reload(true);
		},
	})
		.to(vars.$siteContainer, 0.7, {
			autoAlpha: 0,
		});
}

export function goFromArticleToResult(id) {
	new TimelineMax({
		onComplete() {
			vars.$siteContainer.addClass('is-hidden');
			$('.page.article').addClass('is-hidden');
			TweenMax.set(vars.$siteContainer, {clearProps: 'all'});
			showResult(id);
		},
	})
		.to(vars.$siteContainer, 0.7, {
			autoAlpha: 0,
		});
}

blocks = [
	{
		elements: [
			{
				$element: $('.main__title'),
				durationCoeff: 0.5,
				params: [{y: -500}],
			},
			{
				$element: $('.main__subtitle'),
				durationCoeff: 0.5,
				params: [{y: -500}],
			},
			{
				$element: $('.main__item').eq(0),
				durationCoeff: 0.5,
				params: [{y: -700}],
			},
			{
				$element: $('.main__item').eq(1),
				durationCoeff: 0.5,
				params: [{y: -700}],
			},
			{
				$element: $('.main__item').eq(2),
				durationCoeff: 0.5,
				params: [{y: -700}],
			},
		],
		start: 0,
		scrollDuration: 150,
		enter: () => {
			return true;
		},
		leave: () => {
			return true;
		},
	},
	{
		elements: [
			{
				$element: $('.main__luggage'),
				durationCoeff: 0.6,
				params: [{autoAlpha: 0}],
			},
			{
				$element: $('.main__man'),
				durationCoeff: 0.6,
				params: [{autoAlpha: 0}],
			},
			{
				$element: $('.main__woman'),
				durationCoeff: 0.6,
				params: [{autoAlpha: 0}],
			},
		],
		start: 150,
		scrollDuration: 150,
		enter: () => {
			return true;
		},
		leave: () => {
			return true;
		},
	},
	{
		elements: [
			{
				$element: vars.$mainCircle,
				durationCoeff: 1,
				params: [{
					bottom: innerHeight + vw(424),
					ease: Power0.easeNone,
				}],
			},
		],
		start: 100,
		scrollDuration: 1600,
		enter: () => {
			if (!vars.goToArticle) {
				vars.$pageMain.removeClass('is-hidden');
				vars.$pageTest.addClass('is-hidden');
				vars.$html
					.attr('data-page', 'main')
					.data('page', 'main');
				if (!vars.changeAnimationPage) {
					vars.changePageTest = true;
					router.navigate('/');

					setTimeout(() => {
						vars.changePageTest = false;
					}, 300);
				}
			}
		},
		leave: () => {
			return true;
		},
	},
	{
		elements: [
			{
				$element: $('.main__text-image__text'),
				durationCoeff: 1,
				params: [{
					top: '-100%',
					ease: Power0.easeNone,
				}],
			},
		],
		start: 1600 / 7 * 2,
		scrollDuration: 1600 / 7 * 4,
		enter: () => {
			return true;
		},
		leave: () => {
			if (!vars.goToArticle) {
				vars.$pageMain.removeClass('is-hidden');
			}
		},
	},
	{
		elements: [
			{
				$element: $('.test__item').eq(0),
				durationCoeff: 1,
				params: [{
					top: '-100%',
					ease: Power0.easeNone,
					onStart() {
						vars.$pageTestDescription.addClass('is-opacity');
						vars.$pageTestCounter.addClass('is-opacity');
						$('.test__optionality').addClass('is-opacity');
						$('.test__item__decoration').addClass('is-opacity');
						$('.test__option').addClass('is-opacity');
						new TimelineMax({
							onComplete() {
								vars.$pageTestDescription.removeClass('is-opacity');
								vars.$pageTestCounter.removeClass('is-opacity');
								$('.test__optionality').removeClass('is-opacity');
								$('.test__item__decoration').removeClass('is-opacity');
								$('.test__option').removeClass('is-opacity');
							},
						})
							.to([vars.$pageTestDescription, vars.$pageTestCounter], 0, {
								autoAlpha: 0,
							})
							.to($('.test__optionality'), 0, {
								autoAlpha: 0,
							})
							.to($('.test__item__decoration'), 0, {
								scaleX: 0,
							})
							.to($('.test__option'), 0, {
								autoAlpha: 0,
							});
					},
					onComplete() {
						if (!testAnimated) {
							showTest(false);
						} else {
							$('.header').addClass('on-test');
							new TimelineMax()
								.to([vars.$pageTestDescription, vars.$pageTestCounter], 0.5, {
									autoAlpha: 1,
								})
								.to($('.test__optionality'), 0.5, {
									autoAlpha: 1,
								}, 0);
						}
					},
				}],
			},
			{
				$element: $('.test__item').eq(1),
				durationCoeff: 1,
				params: [{
					top: '100%',
					ease: Power0.easeNone,
				}],
			},
		],
		start: 1700,
		animation: 'from',
		scrollDuration: 500,
		enter: (event) => {
			if (!vars.goToArticle) {
				if (event.scrollDirection === 'REVERSE') {
					$('.header').removeClass('on-test');
					new TimelineMax()
						.to([vars.$pageTestDescription, vars.$pageTestCounter], 0.5, {
							autoAlpha: 0,
						})
						.to($('.test__optionality'), 0.5, {
							autoAlpha: 0,
						}, 0);
				} else {
					vars.$pageTest.removeClass('is-hidden');
					if (!vars.changeAnimationPage) {
						vars.changePageTest = true;
						router.navigate('/test');
						ga('send', 'event', 'test', `question show ${1}`, 'Выберите один из вариантов');

						setTimeout(() => {
							vars.changePageTest = false;
						}, 300);
					}
				}
			}
		},
		leave: (event) => {
			if (event.scrollDirection === 'REVERSE' && !vars.goToArticle) {
				testAnimated = false;
			}
		},
	},
];

$('.result__nav__arrow').on('click', (e) => {
	let $this = $(e.currentTarget);

	let prevId = $this.closest($('.page')).data('result');

	let nav = $this.data('nav');

	let nextId;

	if (nav === 'next') {
		if (prevId !== $('.page.result').length) {
			nextId = prevId + 1;
		} else {
			nextId = 1;
		}
	} else if (nav === 'prev') {
		if (prevId !== 1) {
			nextId = prevId - 1;
		} else {
			nextId = $('.page.result').length;
		}
	}

	router.navigate(`/result/${nextId}`);
});

if (innerWidth <= 1024) {
	vars.$pageMain.swipe({
		swipeUp() {
			swipeToTest();
		},
	});

	vars.$pageTest.swipe({
		swipeDown() {
			animateMobileMain = false;
			swipeToMain();
		},
	});
}

vars.$headerBurger.on('click', () => {
	animateMobileMain = true;
	vars.$mobileNav.removeClass('is-hidden');
	vars.$body.addClass('is-open-menu');
});

vars.$mobileNavClose.on('click', () => {
	animateMobileMain = false;
	vars.$mobileNav.addClass('is-hidden');
	vars.$body.removeClass('is-open-menu');
});
